module.exports = __webpack_public_path__ + "static/media/7.1873f494.jpg";